import React, {useEffect, useState} from "react";
import {
  Portlet,
  PortletBody,
  PortletFooter,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../../components/Portlet";
import {Col, Form, Row, Button, Alert} from "react-bootstrap";
import LoadingButton from "../../../base/components/loadingButton";
import AirBookingSegmentsForm from "./airBookingSegmentsForm";
import AirBookingPaxDataForm from "./аirBookingPaxDataForm";
import moment from "moment";

import ParseInput from "./parseInput";
import {useFieldArray, useForm} from "react-hook-form";
import AirBookingMainForm from "./airBookingMainForm";
import {useNavigatingAway} from "../../../../helpers/useNavigatingAway";
import ModalLivingPage from "../../../../components/layout/ModalLivingPage";
import axios from "../../../../helpers/axios";
import AnimateLoading from "../../../base/components/animateLoading";
import PotentialBuyers from "../../../touristServices/components/potentialBuyers";
import MileCards from "./mileCards";
import PaidButton from "../../../touristServices/components/PaidButton";
import {useParams} from "react-router-dom";
import GoogleItem from "../../../touristServices/components/googleItem";
import _ from "lodash";

import airContext from "./airContext";
import CreateElements from "./createElements";
import {useNavigate} from "react-router";
import {AirBookingCreateRoute, TouristServicesCreateRoute} from "../../../routesConstants";
import BigLogsModal from "../../../../components/BigLogsModal";
import UniversalModalParse from "./universalModalParse";
import LogoFlyArystan from "./logoFlyArystan";
import {toAbsoluteUrl} from "../../../../_metronic";
import StatusFrom1C from "../../../../components/statusFrom1C";
import ParseTextButton from "./parseTextButton";

const AirBookingForm = ({data, onSubmit, className, setter, newForm, loading, edit, reload, savedParseText}) => {
  const {id} = useParams();

  const renderBookingInfo = data => {
    if (!data) {
      return null;
    } else {
      const renderSegment = (segment, index) => {
        const airports =
          segment.departure.airport + " - " + segment.arrival.airport;
        const arrival = moment.utc(segment.arrival.date, 'DD.MM.YYYY');
        const departure = moment.utc(segment.departure.date, 'DD.MM.YYYY');
        const times = segment.departure.time + " - " + segment.arrival.time;
        let dates = departure.format("DDMMM") + " - " + arrival.format("DDMMM");
        if (departure.format("DDMMM") === arrival.format("DDMMM")) {
          dates = departure.format("DDMMM");
        }
        return (
          <small key={index}>
            {airports}, {times}, {dates}
            <br/>
          </small>
        );
      };

      const renderTickets = ({tickets}) => {
        if (tickets === undefined || !tickets.length) {
          return <>(Нет Билетов)</>;
        }
        return tickets.map((ticket, index) => {
          return (
            <div key={index}>
              {ticket.airlineCode}-{ticket.ticketNumber}
              <br/>
            </div>
          );
        });
      };
      return (
        <>
          Бронь {data.bookingNumber} от{" "}
          {moment(data.issueDate, "DD.MM.YYYY HH:mm").format("DD MMM YYYY")}
          <br/>
          {data.segments.map(renderSegment)}
          {data.paxes.map((pax, index) => {
            return (
              <div key={index}>
                <b>
                  {pax.lastName} {pax.firstName}
                </b>
                <br/>
                {renderTickets(pax)}
              </div>
            );
          })}
        </>
      );
    }
  };
  const allItems = []
  data.paxes.forEach(p=>{
    p.tickets.forEach(t=>{
      allItems.push(t)
      t.emds.forEach(e=>{
        allItems.push(e)
      })
    })
  })
  const [suppliers, setSuppliers] = useState();
  const [mainLoading, setMainLoading ] = useState(true);
  const [showErrors, setShowErrors] = useState(false)
  const [potentialBuyers, setPotentialBuyers] = useState()
  const [mileCards , setMileCards] = useState()
  const [parseText, setParseText] = useState('')
  const formController = useForm({defaultValues: data});
  const [airItems, setAirItems] = useState(allItems)
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: {errors, isDirty},
    control,
    setError,
    getValues,
    reset
  } = formController;
  const [canShowModalLivingPage, setCanShowModalLivingPage] = useState(false)
  const navigation = useNavigate()
  const [
    showDialogLeavingPage,
    confirmNavigation,
    cancelNavigation
  ] = useNavigatingAway(canShowModalLivingPage)
  useEffect(() => {
    if (isDirty) {
      setCanShowModalLivingPage(true)
    }
  }, [isDirty])
  useEffect(() => {
    reset(data);
  }, [data]);
  useEffect(() => {
    axios.post('/api/counterparty/suppliers/getAll',{type: 'avia'}).then(({data}) => {
      console.log('supl',data)
      setSuppliers(data.data)
      setMainLoading(false)
    });
  }, []);
  const submitWith1c = (data, e) =>{
    submitAction({...data, importOneS:true},e)
  }
  const submitAction = (data, e) => {
    setCanShowModalLivingPage(false)
    e.preventDefault();
    console.log("refund", data)
    const errors = []
    const checkInput = (value,path) =>{
      if(value<0){
        setError(`${path}`, { type: 'custom', message: 'custom message' })
        errors.push(path)
      }
    }
    data.paxes.forEach((p,pi)=>{
      p.tickets.forEach((t,ti)=>{
        if(!t.refund){
          checkInput(t.fare,`paxes[${pi}].tickets[${ti}].fare`)
          checkInput(t.taxes,`paxes[${pi}].tickets[${ti}].taxes`)
          checkInput(t.penalties,`paxes[${pi}].tickets[${ti}].penalties`)
          checkInput(t.krsBuyer,`paxes[${pi}].tickets[${ti}].krsBuyer`)
          checkInput(t.krsSeller,`paxes[${pi}].tickets[${ti}].krsSeller`)
        }
      })
    })
    if(errors.length===0){
      console.log()
      data.paxes.forEach(p=>{
        p.tickets.forEach(t=>{
          t.tableRecord = _.find(airItems, {id:t.id})?.tableRecord || []
          t.emds.forEach(e=>{
            console.log(e._id, airItems)
            e.tableRecord = _.find(airItems, {_id:e._id})?.tableRecord || []

          })
        })
      })
      console.log('send',data)
      if (parseText) data.parseText = parseText
      onSubmit(data, () => {});
    }
  };

  const segmentsControl = useFieldArray({
    control,
    name: "segments",
    rules: {required: true},
    shouldUnregister: true,
    keyName: 'customId'
  });
  if(mainLoading){
    return <div
      className={`kt-header kt-grid__item kt-header--fixed`}
      id="kt_header"
    >
      <AnimateLoading />

    </div>
  }
  console.log("airItems",airItems)
  const errorsToString = (errors) =>{
    let newObject = []
    const objectVay = (errors,pref)=>{
      Object.keys(errors).forEach(key=>{
        if(Array.isArray(errors[key])){
          const array = errors[key]
          if(array['root']){
            const str = key + ": required;"
            newObject.push(pref ? pref+str: str)
          } else{
            array.forEach((obj,i)=>{
              objectVay(obj,`${key}[${i}]`)
            })
          }
        }else {
          const obj = errors[key]
          const str = key + ': ' +obj.type+ ';'
          newObject.push(pref ? pref+str: str)
        }
      })
    }
    objectVay(errors)
    return newObject
  }

  const copiedBooking = () =>{
    const newData = structuredClone(data)
    delete newData.createdAt
    delete newData.createdBy
    newData.paxes.forEach(pax=>{
      delete pax.id
      pax.tickets.forEach(t=>{
        delete t.id
        t.emds.forEach(e=>{
          delete e.id
          delete e._id
        })
      })
    })
    newData.segments.forEach(s=>delete s.id)
    localStorage.setItem('airbookingCopy', JSON.stringify(newData))
    window.open(window.location.protocol + "//" + window.location.host+AirBookingCreateRoute)
  }

  const setSecondaryInfo = (data) =>{
    setPotentialBuyers(data?.potentialBuyers)
    setMileCards(data?.mileCardsResp)
  }

  return (<>
      <airContext.Provider value={{ airItems, setAirItems }}>
      <ModalLivingPage showDialog={showDialogLeavingPage}
                       setShowDialog={setCanShowModalLivingPage}
                       confirmNavigation={confirmNavigation}
                       cancelNavigation={cancelNavigation}/>
      <div className={"col-12"}>
        <Col xs={12}>
          {data.info && data.info.length ? (
            <Alert variant="info">
              <div className={"alert-text"}>
                {data.info.map((text, i) => (
                  <p key={i}>{text}</p>
                ))}
              </div>
            </Alert>
          ) : null}
        </Col>
        <Row>
          <Col xs={9}>
            <Portlet>
              <PortletHeader
                title={"Редактирование авиа бронирования"}
                toolbar={

                    <PortletHeaderToolbar>
                      {newForm ?
                        <>
                          <UniversalModalParse type={'vietJet'}
                                               setter={setter}
                                               setSecondaryInfo={setSecondaryInfo}>
                            <img src={toAbsoluteUrl("/media/project-logos/VietJet-Air-logo.png")}
                                 height={'40px'}
                                 alt={'vietjet'}/>
                          </UniversalModalParse>
                          <UniversalModalParse type={'flyArystan'}
                                               setter={setter}
                                               setSecondaryInfo={setSecondaryInfo}>
                            <LogoFlyArystan />
                          </UniversalModalParse>
                          <ParseInput setter={setter} url={"/api/air/parse/airBooking"}
                                      setSecondaryInfo={data=>setSecondaryInfo(data)}
                                      onText={setParseText}
                                      keyValue={'airBooking'}
                                      placeholder={"Парс авиа"}/>
                        </>:
                          <div className={'d-flex gap-2 align-items-center'}>
                            <BigLogsModal id={id}/>
                            {data.issuedWithoutDocs &&
                              <PaidButton paid={data.paid} url={'/api/air/airBooking/markPaid/' + id} cb={reload}/>}
                            <Button size={'sm'} onClick={copiedBooking}>Скопировать инвойс</Button>
                          </div>
                      }
                    </PortletHeaderToolbar>
                }
              />
              <div className={className}>
                <form onSubmit={handleSubmit(submitAction)}>
                  <PortletBody className={'pb-1'}>
                    <AirBookingMainForm
                      values={data}
                      formController={formController}
                      setter={setter}
                      suppliers={suppliers}
                    />
                    <AirBookingSegmentsForm
                      segmentsController={segmentsControl}
                      data={data}
                      prefix={"segments"}
                      formController={formController}
                    />
                    <AirBookingPaxDataForm
                      data={data}
                      formController={formController}
                      control={control}
                    />
                    {showErrors && <><p className={'text-danger'}>Список ошибок:</p>
                      {errorsToString(errors).map((str,i)=>{
                      return <div key={i}>
                        {str}<br/>
                      </div>
                    })}</>}
                  </PortletBody>
                  <PortletFooter>
                    <Row>
                      <Col md={{span: 9, offset: 3}}>
                        <LoadingButton title={"Сохранить"} loading={loading} onClick={handleSubmit(submitWith1c)}/>{" "}
                        <Button
                          onClick={() => {
                            console.log("errors", errors);
                            console.log(getValues());
                            setShowErrors(true)
                          }}
                        >
                          Показать ошибки
                        </Button>{" "}
                      </Col>
                    </Row>
                  </PortletFooter>
                </form>
              </div>
            </Portlet>
          </Col>
          <Col xs={3}>
            {potentialBuyers && <PotentialBuyers potentialBuyers={potentialBuyers} setBuyer={id=>setValue('buyer', id)}/> }
            {mileCards && <MileCards mileCards={mileCards}/>}
            <Portlet>
              <PortletHeader title={"Информация по бронированию"}/>
              <PortletBody>
                {renderBookingInfo(data)}
                {edit && <><hr/>Создано: <br/> Кем: {data.createdBy.email} <br/>Когда: {data.createdAt} </>}
                {edit && savedParseText && <ParseTextButton text={savedParseText}/>}
              </PortletBody>
            </Portlet>
            {edit && airItems && <><Portlet>
              <PortletHeader title={'Оплаты в Google'}/>
              <PortletBody>
                {airItems.map((s, i) => {
                  const ticket = !!s.ticketNumber
                  const number = ticket ? s.ticketNumber  : s.emdNumber
                  s.idInOneC= `${s.airlineCode}-${number}${s.refund ? '-В' :''}`
                  return <div key={i} className={i + 1 !== airItems.length ? 'border-bottom mb-2' : ''}>
                    <GoogleItem s={{...s, id: ticket ? s.id : s._id}}
                                i={i}
                                type={ticket ? 'TKT'  : 'EMD'}
                                buyer={watch("buyer")}
                                cb={(data)=>{
                      const updatedIndex = _.findIndex(airItems,{[ticket ? 'ticketNumber'  : 'emdNumber']:number,refund: s.refund})
                      airItems[updatedIndex].tableRecord = data.tableRecord
                      setAirItems([...airItems])
                    }}/>
                  </div>
                })}
              </PortletBody>
            </Portlet>
              <CreateElements airItems={airItems}/>
              {data && !data.issuedWithoutDocs &&
                <StatusFrom1C dataTickets={_.filter(allItems, {isVoid:false}).map((item) => {
                const type = !!item.emdNumber ? "EMD" : "TKT"
                  if(item.id){
                    return {
                      type,
                      refund: item.refund,
                      id: item.id,
                      code: `${item.airlineCode}-${item.ticketNumber||item.emdNumber}${item.refund ? "-В":""}`
                    }
                  }

              })}/>}
            </>
            }
          </Col>
        </Row>
      </div>
      </airContext.Provider>
    </>
  );
};
export default  AirBookingForm;
